// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { QueryWrapperNext } from '@diamond/shared/data-access';
import { Account } from '@diamond/shared/types';

import { useAuthStore } from '../stores';

export const useProfileData = () => {
  const session = useAuthStore();
  const query = QueryWrapperNext('/account', session.access_token);

  const { data, isLoading } = query.useQueryGetById<Account>(
    session.userId,
    'AccountData'
  );

  const detailAccount = {
    email: data?.email,
    number_billto: data?.addresses[0]?.sap_no_bilto,
  };

  const paymentInfo = {
    payment_method: data?.payment_method,
    credit_limit: data?.credit_limit,
  };

  const addresses = data?.addresses;

  const shipTo = data?.ship_tos;

  return {
    isLoading,
    detailAccount,
    paymentInfo,
    addresses,
    shipTo,
  };
};

export default useProfileData;
